import { peripherals } from "@/mocks/homeData";
import type { MemeItem } from "@/mocks/homeData";
import SectionHeader from "./SectionHeader";

interface Props {
  onOpen: (item: MemeItem) => void;
}

export default function PeripheralSection({ onOpen }: Props) {
  return (
    <section id="peripheral" className="bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHeader
          eyebrow="周边衍生"
          title="把吃瓜精神带在身边"
          desc="抱枕、马克杯、贴纸包与联名卫衣等衍生好物灵感展示，喜欢哪件就把它变成日常小确幸。"
        />
        <div className="mt-9 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {peripherals.map((p) => (
            <button
              key={p.id}
              type="button"
              onClick={() => onOpen(p)}
              className="group overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 text-left transition-all hover:-translate-y-1 cursor-pointer"
              aria-label={`查看周边${p.title}`}
            >
              <div className="relative overflow-hidden">
                <img
                  src={p.img}
                  alt={p.alt}
                  className="aspect-[4/3] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-foreground-950/45 text-background-50 opacity-0 backdrop-blur transition-opacity group-hover:opacity-100">
                  <i className="ri-eye-line" />
                </span>
              </div>
              <div className="flex items-center justify-between gap-2 p-4">
                <div className="min-w-0">
                  <h4 className="truncate font-heading text-base text-foreground-950">{p.title}</h4>
                  <p className="mt-1 truncate text-xs text-foreground-500">{p.caption}</p>
                </div>
                <span className="shrink-0 rounded-full bg-accent-100 px-2.5 py-1 text-[11px] font-semibold text-accent-700">
                  {p.tag}
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}